import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import { ActionInterface } from 'common/action.interface';
import { StopsTypes, StopInterface, StopReportsInterface } from './types';

// List Stops
export const listStopsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(StopsTypes.LIST_STOPS_REQUEST, payload);
export const listStopsSuccess = (payload: {
  stopsList: StopInterface[];
  totalCount: number;
}) => action(StopsTypes.LIST_STOPS_SUCCESS, payload);
export const listStopsFailure = () => action(StopsTypes.LIST_STOPS_FAILURE);

// List Stops Full
export const listStopsFullRequest = (payload: {
  body?: object;
  filtering?: boolean;
  transportOperatorId?: string;
}) => action(StopsTypes.LIST_STOPS_FULL_REQUEST, payload);
export const listStopsFullSuccess = (payload: {
  stopsListFull: StopInterface[];
}) => action(StopsTypes.LIST_STOPS_FULL_SUCCESS, payload);
export const listStopsFullFailure = () =>
  action(StopsTypes.LIST_STOPS_FULL_FAILURE);

// List Stops
export const listStopsItineraryRequest = (payload: { body?: object }) =>
  action(StopsTypes.LIST_ITINERARY_STOPS_REQUEST, payload);
export const listStopsItinerarySuccess = (payload: {
  itineraryStopsList: StopInterface[];
  totalCount: number;
}) => action(StopsTypes.LIST_ITINERARY_STOPS_SUCCESS, payload);
export const listStopsItineraryFailure = () =>
  action(StopsTypes.LIST_ITINERARY_STOPS_FAILURE);

// Filter Stops
export const filterStopsRequest = (payload: object) =>
  asyncAction(StopsTypes.FILTER_STOPS_REQUEST, payload);
export const filterStopsSuccess = (payload: {
  stopsList: StopInterface[];
  totalCount: number;
}) => action(StopsTypes.FILTER_STOPS_SUCCESS, payload);
export const filterStopsFailure = () => action(StopsTypes.FILTER_STOPS_FAILURE);

// Get Stop
export const getStopRequest = (payload: object) =>
  action(StopsTypes.GET_STOP_REQUEST, payload);
export const getStopSuccess = (payload: { stopData: StopInterface }) =>
  action(StopsTypes.GET_STOP_SUCCESS, payload);
export const getStopFailure = () => action(StopsTypes.GET_STOP_FAILURE);

// Get Stop Reports
export const getStopReportsRequest = (payload: object) =>
  action(StopsTypes.GET_STOP_REPORTS_REQUEST, payload);

export const getStopReportsSuccess = (payload: {
  stopReports: StopReportsInterface;
}) => action(StopsTypes.GET_STOP_REPORTS_SUCCESS, payload);

export const getStopReportsFailure = () =>
  action(StopsTypes.GET_STOP_REPORTS_FAILURE);

// Create Stop
export const createStopRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) => action(StopsTypes.CREATE_STOP_REQUEST, payload, { dispatchOnSuccess });
export const createStopSuccess = (payload: { stopCreated: StopInterface }) =>
  action(StopsTypes.CREATE_STOP_SUCCESS, payload);
export const createStopFailure = () => action(StopsTypes.CREATE_STOP_FAILURE);

// Update Stop
export const updateStopRequest = (payload: object) =>
  action(StopsTypes.UPDATE_STOP_REQUEST, payload);
export const updateStopSuccess = (payload: { stopData: StopInterface }) =>
  action(StopsTypes.UPDATE_STOP_SUCCESS, payload);
export const updateStopFailure = () => action(StopsTypes.UPDATE_STOP_FAILURE);

// Delete Stop
export const deleteStopRequest = (payload: object) =>
  action(StopsTypes.DELETE_STOP_REQUEST, payload);
export const deleteStopSuccess = () => action(StopsTypes.DELETE_STOP_SUCCESS);
export const deleteStopFailure = () => action(StopsTypes.DELETE_STOP_FAILURE);

// Chips
export const chipsList = (payload: { chipsList: any }) =>
  action(StopsTypes.CREATE_CHIPS_LIST, payload);

export const cleanChipsList = () => action(StopsTypes.CLEAN_CHIPS_LIST);

// Set Selected Start Date
export const setSelectedStartDate = (payload: { selectedStartDate: Date }) =>
  action(StopsTypes.SET_SELECTED_START_DATE, payload);

// Set Selected End Date
export const setSelectedEndDate = (payload: { selectedEndDate: Date }) =>
  action(StopsTypes.SET_SELECTED_END_DATE, payload);
